import { register, findAll, find } from '../../../../Javascript/Utils.js'

const MenuDrawer = el => {
  const componentPrefix = 'oHeaderMenuDrawer-'

  const navItemWithDropdown = findAll(`.${componentPrefix}dropdown`, el)
  navItemWithDropdown.forEach((dropdown) => {
    // const opener = find('a', dropdown);
    const opener = find('span', dropdown)

    opener.addEventListener('click', (e) => {
      e.preventDefault()

      dropdown.classList.toggle(`${componentPrefix}dropdown--open`)

      const submenu = find('ul', dropdown)
      const submenuItems = findAll('li', submenu)
      submenuItems.forEach((submenuItem) => {
        submenuItem.addEventListener('click', (e) => {
          e.stopPropagation()
        })
      })
    })
  })
}

register('MenuDrawer', MenuDrawer)
